import { render } from "./acc-btn.vue?vue&type=template&id=4e2cfc9d"
import script from "./acc-btn.vue?vue&type=script&lang=js"
export * from "./acc-btn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__